const config = {
  apiUrl: (window["env"] && window["env"]["apiUrl"]) || "http://localhost:80/",
  sentryEnabled: (window["env"] && window["env"]["sentryEnabled"]) || false,
  sentryDns: (window["env"] && window["env"]["sentryDns"]) || "https://415c3cf028ff4abfac9c7b0eec6a8813@glitchtip.w4msolutions.com/7",
  sentryEnvironment: (window["env"] && window["env"]["sentryEnvironment"]) || "dev",
  sentryTracesSampleRate: (window["env"] && window["env"]["sentryTracesSampleRate"]) || 0.01,
  maintenanceMode: (window["env"] && (window["env"]["maintenanceMode"] === 'true' || window["env"]["maintenanceMode"] === true)) || false,
};
export { config };
export default config;
